import { formatDate } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";
import { Card, CardContent, CardHeader, Divider, Stack, Switch } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { useGetFacilityProfile } from "@src/appV2/FacilityProfile/api/useGetFacilityProfile";
import { PACIFIC_TIME_ZONE } from "@src/appV2/Timezone/constants";
import { Text, Title, useModalState } from "@src/lib/ui-react";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime } from "date-fns-tz";

import { EditFacilityPendingSettingsDialog } from "./PendedDialog/EditFacilityPendingSettingsDialog";

interface FacilityPendingNoticeProps {
  facilityId: string;
  tmz: string;
}

export function FacilityPendingNotice(props: FacilityPendingNoticeProps) {
  const { facilityId, tmz } = props;
  const {
    data: facilityProfile,
    isSuccess,
    refetch: refetchFacilityProfile,
  } = useGetFacilityProfile(facilityId, "pendingSettings");

  const pendingSettings = facilityProfile?.pendingSettings;
  const currentPendingSettings = {
    // FIXME: Automatically disabled during ESLint config update
    enabled: Boolean(pendingSettings?.enabled),
    // FIXME: Automatically disabled during ESLint config update
    notify: Boolean(pendingSettings?.notify),
    ...(isDefined(pendingSettings?.pendingDate) && {
      pendingDate: utcToZonedTime(pendingSettings.pendingDate, tmz ?? PACIFIC_TIME_ZONE),
    }),
  };

  const editModalState = useModalState();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined">
        <CardHeader title="Billing Alerts" />
        <Divider />
        <CardContent sx={{ paddingBottom: "10px" }}>
          {isSuccess && (
            <EditFacilityPendingSettingsDialog
              modalState={editModalState}
              facilityId={facilityId}
              facilityTmz={tmz}
              pendingSettings={currentPendingSettings}
              onClose={() => {
                editModalState.closeModal();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                refetchFacilityProfile();
              }}
            />
          )}
          <Stack direction="column" spacing={2} alignItems="left">
            <Stack direction="row" spacing={1} alignItems="center">
              <Title component="h4">Pending notice</Title>
              <Switch
                checked={currentPendingSettings.enabled}
                onClick={() => {
                  editModalState.openModal();
                }}
              />
            </Stack>
            {currentPendingSettings?.pendingDate && (
              <Stack direction="row" spacing={1} alignItems="center">
                <Title component="h4">Pending date:</Title>
                <Text>{formatDate(currentPendingSettings?.pendingDate)}</Text>
              </Stack>
            )}
          </Stack>
        </CardContent>
      </Card>
    </LocalizationProvider>
  );
}
